export const BASE_URL = process.env.REACT_APP_BASE_URL; //"https://www.rechtsportal24.de"
export const APP_ENV = process.env.NODE_ENV;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY; // "pk_test_nNPn970uQfv3FalmzvX2hmo000W2BH9nhD"
